module.exports = __webpack_public_path__ + "img/chat-icon02.a5600e8e.png";